export default "__VITE_ASSET__794b16ab__"